import 'es6-promise/auto';
import Vue from 'vue';
import Vuex from 'vuex';
import global from './modules/global';
import coupons from './modules/coupons';
import products from './modules/products';
import submissions from './modules/submissions';
import payments from './modules/payments';
import members from './modules/members';
import contacts from './modules/contacts';
import expenses from './modules/expenses';
import resellers from './modules/resellers';
import resellerTiers from './modules/resellerTiers';
import resellerRewards from './modules/resellerRewards';
import productCreator from './modules/productCreator/index';
import settings from './modules/settings/index';
import sfPages from './modules/sfPages';
import logistics from './modules/logistics';
import funnels from './modules/funnels';
import resellerExchanges from './modules/resellerExchanges';
import dropshipProducts from './modules/dropshipProducts';
import recommendedProducts from './modules/recommendedProducts';
import homepage from './modules/homepage';
import brand from './modules/brand';
import directStore from './modules/direct';
import wishlist from './modules/wishlist';
import productWarehouse from './modules/product-warehouse';
import warehouse from './modules/warehouse';
import productRequest from './modules/product-request';
import sales from './modules/sales';
import salesMonitoring from './modules/sales-monitoring';
import sidebar from './modules/sidebar';
import notifications from './modules/notifications';
// import createLogger from '../../src/plugins/logger';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

const plugins = [];

if (debug) {
	// plugins.push(createLogger());
}

const store = new Vuex.Store({
	modules: {
		global,
		coupons,
		products,
		submissions,
		payments,
		members,
		contacts,
		expenses,
		resellers,
		resellerTiers,
		productCreator,
		settings,
		sfPages,
		logistics,
		funnels,
		resellerRewards,
		resellerExchanges,
		dropshipProducts,
		recommendedProducts,
		homepage,
		brand,
		directStore,
		wishlist,
		productWarehouse,
		warehouse,
		productRequest,
		sales,
		salesMonitoring,
		sidebar,
		notifications,
	},
	strict: debug,
	plugins,
});

export default store;
